<div class="row">
    <div class="col-12">
        <div class="listCategorias row text-center">
            <div class="col-2 social" (click)="toggleSocial()" style="cursor: pointer;">
                <img src="assets/img/icon/social.png" width="100%" alt="Guatemaltecos Ilustres">
                <span>Social</span>
            </div>
            <div class="col-2 deporte" (click)="toggleDeporte()" style="cursor: pointer;">
                <img src="assets/img/icon/deporte.png" width="100%" alt="Guatemaltecos Ilustres">
                <span>Deporte</span>
            </div>
            <div class="col-2" (click)="toggleCiencia()" style="cursor: pointer;">
                <img src="assets/img/icon/ciencia.png" width="100%" alt="Guatemaltecos Ilustres">
                <span>Ciencia</span>
            </div>
            <div class="col-2" (click)="toggleEmpresarial()" style="cursor: pointer;">
                <img src="assets/img/icon/empresarial.png" width="100%" alt="Guatemaltecos Ilustres">
                <span>Empresarial</span>
            </div>
            <div class="col-2" (click)="toggleArte()" style="cursor: pointer;">
                <img src="assets/img/icon/arte.png" width="100%" alt="Guatemaltecos Ilustres">
                <span>Arte</span>
            </div>
        </div>
    </div>
</div>

<c-modal id="liveDemoModal" [visible]="categoriaSocial" (visibleChange)="handleSocial($event)" size="xl">
    <c-modal-body>
        <div class="row text-right controles">
            <button class="btn btn-danger" (click)="toggleSocial()"> x </button>
        </div>
        <div class="row text-center">
            <img src="assets/img/icon/social.png" width="100%" alt="Guatemaltecos Ilustres">
        </div>
        <div class="row text-center">
            <h5> CATEGORÍA SOCIAL</h5>
        </div>
        <div class="row">
            <p>
                Un Guatemalteco Ilustre que corresponde a la categoría social, siempre reconoce el valor en una persona
                y sabe que el respeto es la base de vida en armonía en una sociedad.

                Dedica tiempo para entender a las personas y busca la forma de poder ayudar a que sus vidas sean
                mejores. Da todo de sí mismo, porque sabe que dar es mucho mejor que recibir.

                La categoría social abarca todo tipo de acciones de apoyo social entre las cuales podemos mencionar:
                ayuda familiar, de vivienda, estudiantil y ambiental; voluntariado, capacitaciones, servicios
                comunitarios, aporte a la educación y pedagogía, apoyo en medios de comunicación y otras actividades
                sociales.
            </p>
        </div>
    </c-modal-body>
</c-modal>


<c-modal id="liveDemoModal" [visible]="categoriaDeporte" (visibleChange)="handleDeporte($event)" size="xl">
    <c-modal-body>
        <div class="row text-right controles">
            <button class="btn btn-danger" (click)="toggleDeporte()"> x </button>
        </div>
        <div class="row text-center">
            <img src="assets/img/icon/deporte.png" width="100%" alt="Guatemaltecos Ilustres">
        </div>
        <div class="row text-center">
            <h5> CATEGORÍA DEPORTE</h5>
        </div>
        <div class="row">
            <p>
                Un Guatemalteco Ilustre que se destaca en la categoría deportiva vive cada día una ardua rutina de
                esfuerzo y disciplina para vencerse a sí mismo. Lucha con todas las fuerzas para derrotar todos los
                obstáculos y levantarse con la valentía a pesar de caer. Sabe que para alcanzar la cima, es necesario
                dar todo y después dar aún más.

                La categoría deportiva abarca todas las disciplinas del deporte competitivo, entre las cuales podemos
                mencionar: atletismo, gimnasia, ciclismo, pentatlón, baloncesto, tenis, voleibol, fútbol, tiro, béisbol,
                artes marciales y natación entre otros.
            </p>
        </div>
    </c-modal-body>
</c-modal>


<c-modal id="liveDemoModal" [visible]="categoriaCiencia" (visibleChange)="handleCiencia($event)" size="xl">
    <c-modal-body>
        <div class="row text-right controles">
            <button class="btn btn-danger" (click)="toggleCiencia()"> x </button>
        </div>
        <div class="row text-center">
            <img src="assets/img/icon/ciencia.png" width="100%" alt="Guatemaltecos Ilustres">
        </div>
        <div class="row text-center">
            <h5> CATEGORÍA CIENTÍFICA</h5>
        </div>
        <div class="row">
            <p>
                Un Guatemalteco Ilustre que pertenece a la categoría científica, busca siempre hacer lo que nadie nunca
                ha logrado hacer antes. Sabe que todo lo que existe puede hacerse mejor, por eso reta constantemente los
                paradigmas y sigue su intuición. Es dedicado hasta en el más pequeño de los detalles y la innovación es
                siempre parte de lo que hace.

                La categoría científica incluye todas las ramas de las ciencias naturales y las ciencias formales, entre
                las cuales podemos mencionar: astrología, física, geología, química, medicina, biología, matemática,
                estadística, lógica, ciencias de la computación y robótica entre otras.
            </p>
        </div>
    </c-modal-body>
</c-modal>


<c-modal id="liveDemoModal" [visible]="categoriaEmpresarial" (visibleChange)="handleEmpresarial($event)" size="xl">
    <c-modal-body>
        <div class="row text-right controles">
            <button class="btn btn-danger" (click)="toggleEmpresarial()"> x </button>
        </div>
        <div class="row text-center">
            <img src="assets/img/icon/empresarial.png" width="100%" alt="Guatemaltecos Ilustres">
        </div>
        <div class="row text-center">
            <h5> CATEGORÍA EMPRESARIAL</h5>
        </div>
        <div class="row">
            <p>
                Un Guatemalteco Ilustre que se distingue en la categoría empresarial siempre tiene la vista fija en su
                objetivo, avanzando hacia él sin rendirse a pesar de la adversidad que le rodee.

                Es perseverante y se mantiene firme porque sabe que las mejores recompensas son de los que saben
                esperar. Siempre tiene una meta que alcanzar y nunca le teme a las dificultades, porque sabe cómo
                convertirlas en oportunidades.

                La categoría empresarial abarca todo tipo de logros empresariales entre los que podemos mencionar:
                Empresas de tradición, empresas nuevas, empresas locales, empresas transnacionales, emprendimiento,
                exportaciones e importaciones, agroindrustria, manufactura, creación de sus propias marcas y productos
                entre otros.
            </p>
        </div>
    </c-modal-body>
</c-modal>


<c-modal id="liveDemoModal" [visible]="categoriaArte" (visibleChange)="handleArte($event)" size="xl">
    <c-modal-body>
        <div class="row text-right controles">
            <button class="btn btn-danger" (click)="toggleArte()"> x </button>
        </div>
        <div class="row text-center">
            <img src="assets/img/icon/arte.png" width="100%" alt="Guatemaltecos Ilustres">
        </div>
        <div class="row text-center">
            <h5> CATEGORÍA ARTÍSTICA</h5>
        </div>
        <div class="row">
            <p>
                Un Guatemalteco Ilustre que sobresale en la categoría artística, se caracteriza por vivir con pasión
                cada detalle de su arte, ya sea en los sonidos de una melodía, o en los brochazos de colores sobre un
                lienzo. Es un inventor por naturaleza, crea mundos y personajes que llevan al lector a través de páginas
                llenas de aventura, romance y llanto. Las ideas siempre le rodean a donde sea que vaya, porque un
                artista sobresaliente es también un creativo sobresaliente.

                La categoría artística abarca las artes clásicas y las artes modernas entre las cuales podemos
                mencionar: arquitectura, escultura, pintura, literatura, danza, música, fotografía, el cine y el diseño
                gráfico.
            </p>
        </div>
    </c-modal-body>
</c-modal>